
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 960 480"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#239e46","d":"M0 0h960v480H0z"}}),_c('path',{attrs:{"d":"M0 0h960v360H0z"}}),_c('path',{attrs:{"fill":"#e70013","d":"M0 0h960v120H0z"}}),_c('circle',{attrs:{"cx":"480","cy":"240","r":"60","fill":"#fff"}}),_c('circle',{attrs:{"cx":"492.132","cy":"240","r":"52.132"}}),_c('path',{attrs:{"d":"M509.175 240l80.7-26.221L540 282.426v-84.852l49.875 68.647z","fill":"#fff"}})])
          )
        }
      }
    